import { SchemaColumnOptions, SchemaTableOptions } from "@/vendors/prx-sqlite/Interfaces/SchemaInterfaces";
export const data_dictionaries:SchemaTableOptions = {
    name:<string> 'data_dictionaries',
    schema:<Array<SchemaColumnOptions>> [
        { column: 'id', value: 'INTEGER PRIMARY KEY AUTOINCREMENT'},
        { column: 'name', value: 'VARCHAR(255) NOT NULL'},
        { column: 'content', value: 'TEXT NOT NULL'},
    ]
}